import { Box, Button, CircularProgress, Divider, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type PinnacleConfirmDeleteItemProps = {
  title: string;
  itemToDelete: string;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  onCancel: () => void;
};

const PinnacleConfirmDeleteItem: React.FC<PinnacleConfirmDeleteItemProps> = ({
  title,
  itemToDelete,
  isDeleting,
  onClose,
  onDelete,
  onCancel
}) => {
  return (
    <Box p={3} pt={3} minWidth={500}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h3">{title}</Typography>
        <IconButton size="medium" onClick={onClose}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Message */}
      <Typography variant="h4" sx={{ pb: 5 }}>
        Are you sure you want to delete{" "}
        <Typography variant="h4" component="span" fontWeight={600}>
          {itemToDelete}
        </Typography>
        ?
      </Typography>

      {/* Actions */}
      <Box
        display="flex"
        justifyContent="flex-start"
        gap={1}
        mt={3}
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <Button
          variant="contained"
          fullWidth
          onClick={onDelete}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <CircularProgress size={24} sx={{ color: "#90caf9" }} />
          ) : (
            "YES, DELETE"
          )}
        </Button>
        <Button
          variant="outlined"
          fullWidth onClick={onCancel}
          disabled={isDeleting}
          sx={{
            border: '1px solid rgba(168, 168, 168, 1)',
            color: 'rgba(55, 55, 55, 1)'
          }}
        >
          CANCEL
        </Button>
      </Box>
    </Box>
  );
};

export default PinnacleConfirmDeleteItem;
